import { render, staticRenderFns } from "./MyNews.vue?vue&type=template&id=4844931d&scoped=true"
import script from "./MyNews.vue?vue&type=script&lang=js"
export * from "./MyNews.vue?vue&type=script&lang=js"
import style0 from "./MyNews.vue?vue&type=style&index=0&id=4844931d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4844931d",
  null
  
)

export default component.exports